
export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  }
}
